import { createAppWrap } from '../../create_app_wrap';
import modalMixin from '../../mixins/_modal';
import commonMixin from '../../mixins/_common';
import modalBillInfoEditor from '../../components/_modal_bill_info_editor';
import flashMessageMixin from '../../mixins/_flash_messages';

const STATUS = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
};

const CHURN_REASON = {
    UNSATISFIED: '必要な機能がなかった、やりたい事ができなかった',
    HOLD: '一旦解約して必要な時にまた使いたい',
    DIFFICULT: '分かりづらくて使いこなせなかった',
    LEAVING: 'Yahoo!ストアを退店するため',
    ETC: 'その他',
};

const view = '[data-view="account"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                isDispPaymentBtn: false,
                billing: null,
                defaultCard: null,
                churnReason: null,
            };
        },
        components: {
            modalBillInfoEditor,
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            modalMixin, commonMixin, flashMessageMixin,
        ],
        /**
         * 算出プロパティ
         */
        computed: {
            // billingデータが存在するか
            existBilling: function () {
                return (this.billing && Object.keys(this.billing).length > 0);
            },
            // billing.statusが失敗しているか
            isBillingStatusFailed: function () {
                return (this.existBilling && this.billing.status === STATUS.FAILED);
            },
            // 解約理由
            churnReasonSelect: function () {
                return CHURN_REASON;
            },
        },
        created: function() {
            const billingData = document.querySelector('[data-roll="billing"]');
            if (billingData) {
                this.billing = JSON.parse(billingData.innerHTML);
            }

            const defaultCardData = document.querySelector('[data-roll="default-card"]');
            if (defaultCardData) {
                this.defaultCard = JSON.parse(defaultCardData.innerHTML);
            }

            if (this.isBillingStatusFailed) {
                this.isDispPaymentBtn = true;
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            cancelContract: function(isFirstOfMonth) {
                if (this.isBillingStatusFailed) {
                    this._modal = $('#modal_decline_cancell_for_unpaid');
                    this.open();
                    return;
                }

                if (isFirstOfMonth) {
                    // 毎月一日は解約を受け付けない
                    this._modal = $('#modal_deny_cancell');
                    this.open();
                    return;
                }

                this._modal = $('#modal_cancell');
                this.open();
                return;
            },
            /**
             * お支払い情報更新処理
             */
            async submitBilling (postParams) {
                this.$_loading();
                try {
                    const response = await axios.post('/billing/edit', {
                        _method: 'POST',
                        staff_name: postParams.staff_name,
                        email: postParams.email,
                        token: postParams.token
                    });
                    if (response.data.status === 'OK') {
                        this._modal = $('#modal-bill-info-editor');
                        this.close();
                        this.appendFlashMessage({
                            level: 'alert-success',
                            message: '変更が完了しました',
                        }, this.$parent);

                        // 更新後データで表示データ更新
                        this.billing = response.data.billing;
                        this.defaultCard = response.data.defaultCard;

                    }
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    }, this.$parent);
                }
                this.$_unloading();
            },
            /**
             * 定期支払い再開処理
             */
            async resumeSubscription () {
                try {
                    const response = await axios.post('/billing/resumeSubscription', {
                        _method: 'POST',
                    });
                    if (response.data.status === 'OK') {
                        this.close();
                        this.appendFlashMessage({
                            level: 'alert-success',
                            message: 'お支払いを受付けました。結果はメールで送信されます。',
                        });
                        this.isDispPaymentBtn = false;
                    }
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    });
                }
            },
            /**
             * ローディング画面表示処理
             */
            showLordingScreen: function() {
                this.$_loading();
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
